<template>
    <navbar>
        <button class="navbar-toggler mobile-sidebar-toggler hidden-lg-up" type="button" @click="mobileSidebarToggle">&#9776;</button>
        <a class="navbar-brand hidden-md-down" href="#"></a>
        <ul class="nav navbar-nav hidden-md-down">
            <li class="nav-item">
                <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarToggle">&#9776;</a>
            </li>
        </ul>

        <header-search-input></header-search-input>
        <ul class="nav navbar-nav ml-auto">
            <li class="nav-item" v-if="user.hasPermission('order.add')">
                <a href="#" class="nav-link add-order-link" @click.stop.prevent v-b-modal.ModalEditOrder>
                    <i class="fa fa-plus px-1"></i>
                    <span class="hidden-sm-down">Добавить заказ</span>
                </a>
            </li>
            <li class="nav-item dropdown d-md-down-none show">
                <a class="nav-link nav-link" data-toggle="dropdown" href="#" @click.prevent="showNotifications = !showNotifications" role="button" aria-haspopup="true" aria-expanded="true">
                    <i class="icon-bell"></i>
                    <span  v-if="paginator.totalCount" class="badge badge-pill badge-warning">{{paginator.totalCount}}</span>
                </a>
                <div v-if="showNotifications" class="dropdown-menu dropdown-menu-right dropdown-menu-lg">
                    <div class="dropdown-header text-center">
                        <strong v-if="paginator.totalCount">У вас {{paginator.totalCount}} непрочитанных уведомлений</strong>
                        <strong v-else>У вас нет непрочитанных уведомлений</strong>
                    </div>
                    <div class="infinity-loading">
                    <a v-for="notification in notifications" :key="notification.id" href="#" @click.prevent="showOrderDetail(notification.objectId)" class="dropdown-item" :class="{ 'bg-light-warning': !notification.isViewed}">
                        <i :class="notification.iconClass"></i>
                        <span class="small">{{notification.diffForHumans}}</span>
                        {{notification.text}}
                    </a>
                    <infinite-loading @infinite="infiniteHandler" ref="notificationsLoading">
                        <span slot="spinner">
                            <div class="mt-1 mb-1">
                                <loading :size="2" message="Загружаем уведомления..."></loading>
                            </div>
                        </span>
                        <span slot="no-more">Уведомлений больше нет :)</span>
                    </infinite-loading>
                    </div>
                    <div v-if="paginator.totalCount" @click.prevent="markAllAsViewed" class="dropdown-header text-center cursor-pointer">
                        <loading v-if="loadingMarkAsRead" :size="2" :message="false"></loading>
                        <strong v-else="">Отметить все как прочитанные</strong>
                    </div>
                </div>
            </li>
            <b-dropdown id="profile-dropdown" variant="link">
                <span slot="button-content">
                  <img :src="getAvatarPath(user.avatar)" class="img-avatar">
                  <span class="hidden-md-down">{{user.firstname|truncate(12)}}</span>
                </span>
                <b-dropdown-item aria-describedby="profile" @click.prevent="goToProfile">
                    <i class="fa fa-user"></i> Профиль
                </b-dropdown-item>
                <b-dropdown-item aria-describedby="header1" @click.prevent="logout"><i class="fa fa-lock"></i> Выйти</b-dropdown-item>
            </b-dropdown>
        </ul>
    </navbar>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import navbar from './Navbar'
  import HeaderSearchInput from './HeaderSearchInput.vue'
  import { storageUrl, logout } from './../config'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    name: 'header',
    computed: mapState({
      user: state => state.globalStore.user,
      notifications: state => state.globalStore.notifications,
      paginator: state => state.globalStore.notificationsPaginator
    }),
    components: {
      navbar,
      HeaderSearchInput,
      InfiniteLoading
    },
    data () {
      return {
        showNotifications: false,
        loadingMarkAsRead: false
      }
    },
    methods: {
      showOrderDetail (id) {
        this.showNotifications = false
        this.$store.dispatch('showOrderDetail', id)
      },
      click () {
        // do nothing
      },
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      },
      /**
       * Выход из CRM
       */
      logout: function () {
        logout()
      },
      /**
       * Метод возвращает полный пут к аватарке пользователя
       * @param path
       * @return {string}
       */
      getAvatarPath (path) {
        return storageUrl + path
      },
      /**
       * Подгрузка уведомлений
       */
      infiniteHandler ($state) {
        this.$store.dispatch('loadNotifications')
          .then(() => {
            $state.loaded()
          }).catch(() => {
            $state.complete()
          })
      },
      /**
       * Помеить все сообщения как прочитанные
       */
      markAllAsViewed () {
        this.loadingMarkAsRead = true
        this.$store.dispatch('markAllNotificationsAsViewed').then(() => {
          this.addToast({
            text: 'Все сообщения помечены как прочитанные',
            type: 'success',
            dismissAfter: 3000
          })
          this.loadingMarkAsRead = false
          this.showNotifications = false
        }).catch(() => {
          this.loadingMarkAsRead = false
          this.addToast({
            text: 'Произошла ошибка. Попробуйте еще раз или обратитесь к администратору',
            type: 'error',
            dismissAfter: 3000
          })
        })
      },
      /**
       * Показать модальное окно добавления заказа
       */
      showEditModal () {
        this.$store.commit('SET_SHOW_ORDER_MODAL', 'addEditOrder')
      },
      goToProfile () {
        this.$router.push({name: 'Profile'})
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    }
  }
</script>

<style lang="scss" scoped>
    .dropdown-toggle::after {
        /*display: none !important;*/
    }
    .infinity-loading{
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .cursor-pointer {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// Header.vue?409055de